import { useEffect } from "react";
import PropTypes from "prop-types";
import { useWorkspaceContext } from "../contexts/WorkspaceContext";

export function AvatarPersistenceManager({ store, controller }) {
  const { getDefaultWorkspace } = useWorkspaceContext();
  const defaultWorkspaceId = getDefaultWorkspace()?.id ?? null;
  const accountId = store.state.authUser?.id ?? null;
  const avatarUrl = accountId == null ? null : store.state.authUser?.avatar ?? null;

  useEffect(() => {
    void controller.synchronize({ accountId, avatarUrl, workspaceId: defaultWorkspaceId });
  }, [controller, accountId, avatarUrl, defaultWorkspaceId]);

  return null;
}

AvatarPersistenceManager.propTypes = {
  store: PropTypes.object.isRequired,
  controller: PropTypes.shape({ synchronize: PropTypes.func.isRequired }).isRequired
};
